import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Iconify from "../../../components/ui/iconify/Iconify";
import { sidebarMenuConfig } from "./config/sidebarmenu.config";
import "./Sidebar.scss";
import { getAuthProps, signOut } from "../../../lib/authenticationLibrary";
const Sidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  // const {user:{adminFlag}} = getAuthProps();
  const [selectedMenu, setSelectedMenu] = useState(1);
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);
  const [navigationMenuList, setNavigationMenuList] = useState(null);

  useEffect(() => {
    // ================= filter routs using admin flag 
    try {
      const { user } = getAuthProps();
      const adminFlag = user?.adminFlag ?? 0;
      const menu = adminFlag === 0 ? sidebarMenuConfig.filter(item => item.id !== "administrator") : sidebarMenuConfig;
      setNavigationMenuList(menu);
    } catch (error) {
      signOut()
    }
    // setNavigationMenuList(sidebarMenuConfig);
    const lastSegment = currentPath.split("/").pop().toLowerCase();
    sidebarMenuConfig.forEach((menuItem) => {
      if (menuItem.children) {
        menuItem.children.forEach((group) => {
          group.items.forEach((subMenuItem) => {
            if (subMenuItem.navigationPath === currentPath) {
              setSelectedMenu(menuItem.menuKey);
              setSelectedSubMenu(subMenuItem.menuKey);
            }
          });
        });
      }
    });
  }, [location.pathname]);

  const handleClick = (menuKey, e) => {
    if (e) e.stopPropagation();
    setSelectedMenu((prevSelectedMenu) =>
      prevSelectedMenu === menuKey ? null : menuKey
    );
    setSelectedSubMenu(null);
  };

  const handleSubMenuClick = (subMenuKey, e) => {
    if (e) e.stopPropagation();
    setSelectedSubMenu(subMenuKey);
  };

  return (
    <nav className="sidebar">
      <ul className="sidebar-menu-list">
        {navigationMenuList?.map((menuItem) => {
          return (
            <li key={menuItem.menuKey} className="menu-item">
              <button
                onClick={(e) => handleClick(menuItem.menuKey, e)}
                className={`menu-button ${
                  selectedMenu === menuItem.menuKey ? "active-menu" : ""
                }`}
              >
                <Link
                  to={menuItem.navigationPath}
                  className={menuItem.children ? "menu-arrow" : ""}
                >
                  <Iconify icon={menuItem.menuIcon || "ep:menu"} width={16} />
                  <div className="menu-item-title">{menuItem.menuTitle}</div>
                  {menuItem.children && menuItem.children.length > 0 && (
                    <Iconify icon="ep:arrow-down-bold" width={15} className="dropdown-item-icon"/>
                  )}
                </Link>
              </button>
              {selectedMenu === menuItem.menuKey &&
                menuItem.children.length > 0 && (
                  <ul className="sidebar-dropdown">
                    {menuItem.children.map((group, index) => (
                      <React.Fragment key={index}>
                        {group.groupLabel && (
                          <li className="group-label">{group.groupLabel}</li>
                        )}
                        {group.items.map((item) => (
                          <li key={item.menuKey} className="dropdown-item">
                            <button
                              onClick={(e) =>
                                handleSubMenuClick(item.menuKey, e)
                              }
                              className={`child-menu-button ${
                                selectedSubMenu === item.menuKey
                                  ? "active-submenu"
                                  : ""
                              }`}
                            >
                              <Link
                                to={item.navigationPath}
                                className="child-menu-arrow"
                              >
                                <Iconify
                                  icon={
                                    item.menuIcon ||
                                    "icon-park-outline:nested-arrows"
                                  }
                                  width={16}
                                />
                                {item.subMenuName}
                              </Link>
                            </button>
                          </li>
                        ))}
                      </React.Fragment>
                    ))}
                  </ul>
                )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;
